import styled from 'styled-components';

export const ListAppointmentPageStyled = styled.div`
  background-color: #f4f3f3;

  .title-page {
    padding-top: 1%;
  }

  .row-field-filter {
    //padding-bottom: 2%;
  }

  .calendario-container {
    max-height: 80vh; /* Define a altura máxima do container */
    overflow-y: auto; /* Adiciona scroll vertical apenas no container */
    padding: 20px;
  }

  .calendario-grid {
    display: grid;
    grid-template-columns: 1fr; /* Exibe apenas um calendário por linha */
    gap: 20px; /* Espaçamento entre os calendários */
  }

  .container-field-canvas {
    padding-bottom: 5%;
  }

  .fc .fc-toolbar-title {
    font-size: 0.8em;
    margin: 0px;
  }
`;

export const CanvasPageStyled = styled.div`
  .container-field-canvas {
    padding-bottom: 1%;

    .row-field-canvas {
      padding: 15px 0px 0px 0px;
    }
  }
`;
